import { PAYMENT } from './constants/payment';

export const isFiatPayment = paymentName => PAYMENT.FIAT === paymentName;
export const isCheckPayment = paymentName => PAYMENT.CHECK === paymentName;
export const isAchPayment = paymentName => PAYMENT.ACH === paymentName;
export const isWirePayment = paymentName => PAYMENT.WIRE === paymentName;